/* ZAÏT — charge le moteur de dessin du composeur et de la Table du mois.
   Le moteur (zait-art, zait-room, zait-composer) est découpé en parties : elles sont lues dans l'ordre, réunies, puis exécutées une seule fois. */
(function(){
  'use strict';
  var me=document.currentScript;
  if(!me||window.ZENGINE)return;
  window.ZENGINE=true;
  var urls=(me.getAttribute('data-parts')||'').split(',').filter(function(u){return u});
  if(!urls.length||!window.fetch)return;
  Promise.all(urls.map(function(u){return fetch(u).then(function(r){if(!r.ok)throw new Error(u+' '+r.status);return r.text()})}))
    .then(function(parts){var s=document.createElement('script');s.textContent=parts.join('');document.head.appendChild(s)})
    .catch(function(e){if(window.console)console.error('ZAÏT : moteur de dessin indisponible',e)});
})();
